// @ai-generated 2026-09-07T00:00:00+00:00 by niklas.eicker@tngtech.com using Claude Opus 5 (1M context)
import { useAgenticOrchestratorRepository } from '@Hooks/useRepository';
import type { ApiWorkflowDefinition } from '@Model';
import { WorkflowDefinitionsRepository } from '@Repositories/AgenticOrchestrator';
import {
    EnumFilterExpressionOperation,
    EnumOperation,
    type Index,
    type ListRequest,
} from '@synqo/frontend-component-library';
import { useQuery } from '@tanstack/react-query';

const keyField: Index<ApiWorkflowDefinition> = 'definition_key';

/**
 * Looks a workflow definition up by its key, e.g. `monthly_faktura`. By key rather than by id because
 * the definition is a seeded row, whose id is data the frontend cannot carry.
 */
export function useWorkflowByKey(definitionKey: string) {
    const workflowDefinitions = useAgenticOrchestratorRepository(WorkflowDefinitionsRepository);

    const request: ListRequest = {
        page_no: 0,
        page_size: 1,
        full_text_search: '',
        sort_columns: [],
        filter_columns: {
            operation: EnumFilterExpressionOperation.And,
            filters: [{ field: keyField, value: definitionKey, operator: EnumOperation.Equal }],
        },
    };

    const { data, isLoading } = useQuery({
        queryKey: ['agentic-orchestrator', 'workflow_definitions', 'by-key', definitionKey],
        queryFn: () => workflowDefinitions.getListPost(request, ''),
        enabled: definitionKey !== '',
    });

    return { workflow: data?.data?.items?.[0], isLoading };
}
